import { createFileRoute } from '@tanstack/react-router';

import { useGetSuperadminAnalytics } from '../../../api/generated/api';
import { AnalyticsPage, superadminAnalyticsCatalogGroups } from '../../../modules/analytics';
import { dateRangeSearchSchema, resolveDateRange } from '../../../ui/components/date-range-filter';

const AnalyticsRoute = () => {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();
  const { from, to } = resolveDateRange(search);
  const { data, isPending, isFetching, error } = useGetSuperadminAnalytics({
    from: from.startOf('day').toISOString(),
    to: to.endOf('day').toISOString(),
  });

  return (
    <AnalyticsPage
      storageKey="k3x.analytics.superadmin"
      catalogGroups={superadminAnalyticsCatalogGroups}
      defaultMetricIds={['org-total', 'org-new', 'crm-leads', 'crm-emails', 'crm-calls']}
      metricsById={data?.data.metrics ?? {}}
      loading={data ? isFetching : isPending}
      error={error}
      search={search}
      onSearchChange={(nextSearch) => navigate({ search: nextSearch })}
      hasSidebarGutter={false}
    />
  );
};

export const Route = createFileRoute('/_authenticated/superadmin/analytics')({
  component: AnalyticsRoute,
  validateSearch: dateRangeSearchSchema,
});
